module.exports = __webpack_public_path__ + "static/media/mining-1.e00a6893.png";